import React, { useState } from "react";
import { OnboardingFormData } from "..";

interface BirthdayStepProps {
  formData: OnboardingFormData;
  updateFormData: (data: Partial<OnboardingFormData>) => void;
  onNext?: () => void;
  onSkip?: () => void;
  isLoading?: boolean;
}

const BirthdayStep: React.FC<BirthdayStepProps> = ({
  formData,
  updateFormData,
}) => {
  const [birthday, setBirthday] = useState({
    month: formData.birthday?.month || "",
    day: formData.birthday?.day || "",
    year: formData.birthday?.year || "",
  });

  const handleInputChange = (
    field: "month" | "day" | "year",
    value: string,
  ) => {
    // Validate input
    if (value === "" || /^\d+$/.test(value)) {
      const newBirthday = {
        ...birthday,
        [field]: value,
      };
      setBirthday(newBirthday);
      updateFormData({ birthday: newBirthday });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 py-6 space-y-6 bg-[#FBF6F1]">
      {/* Illustration - Hidden for now */}
      <div className="flex flex-col justify-center items-center gap-2.5">
        <img
          src="/icons/birthday-illustration.svg"
          alt="Birthday"
          className="w-34 h-34"
        />
      </div>

      {/* Title */}
      <div className="text-center">
        <h1 className="text-2xl font-semibold font-inter text-midnight-blue leading-7">
          Nhập ngày sinh của bạn
        </h1>
      </div>

      {/* Description */}
      <div className="text-center max-w-sm">
        <p className="text-sm font-normal font-inter text-midnight-blue/60 leading-tight">
          Cung cấp ngày sinh sẽ cá nhân hóa trải nghiệm của bạn trên Locuno và
          giúp chúng tôi tuân thủ pháp luật
        </p>
      </div>

      {/* Learn More Link */}
      <div className="text-center">
        <a className="text-xs font-normal font-inter text-burnt-orange underline leading-none cursor-pointer">
          Tìm hiểu thêm
        </a>
      </div>

      {/* Birthday Inputs */}
      <div className="flex items-center gap-2 w-full max-w-sm">
        <div className="flex-1 h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-midnight-blue/20 flex justify-center items-center">
          <input
            type="text"
            placeholder="Tháng"
            value={birthday.month}
            onChange={(e) => handleInputChange("month", e.target.value)}
            maxLength={2}
            className="w-full text-center bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-inter"
          />
        </div>
        <div className="text-midnight-blue/60 text-base font-normal font-inter">/</div>
        <div className="flex-1 h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-midnight-blue/20 flex justify-center items-center">
          <input
            type="text"
            placeholder="Ngày"
            value={birthday.day}
            onChange={(e) => handleInputChange("day", e.target.value)}
            maxLength={2}
            className="w-full text-center bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-inter"
          />
        </div>
        <div className="text-midnight-blue/60 text-base font-normal font-inter">/</div>
        <div className="flex-1 h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-midnight-blue/20 flex justify-center items-center">
          <input
            type="text"
            placeholder="Năm"
            value={birthday.year}
            onChange={(e) => handleInputChange("year", e.target.value)}
            maxLength={4}
            className="w-full text-center bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-inter"
          />
        </div>
      </div>
    </div>
  );
};

export default BirthdayStep;
